export default {
  getScenarioDistrictOptions: (state) => state.scenarioDistrictOptions,
  getScenarioRefurbishmentOptions: (state) =>
    state.scenarioRefurbishmentOptions,
  getScenariosSuccess: (state) =>
    state.scenarios.filter((e) => e.progress === 0),
  getScenarioNames: (state) => state.scenarios.map((e) => e.name),
  getScenarioYears: (state) => state.scenarioSelected.years,
  getSelectedScenario: (state) => state.scenarioSelected,
  getScenarios: (state) => state.scenarios,
};
